import React from 'react';
import { AddressType } from '../CommonTypes';
import { t } from 'i18next';

type AddressProps = {
    id: string;
    address: AddressType;
    showEditButton: boolean;
    onEditAddressClick: () => void;
};

const Address = ({
    id,
    address,
    onEditAddressClick,
    showEditButton
}: AddressProps): JSX.Element => {
    const {
        addressLine1,
        addressLine2,
        townOrCity,
        region,
        postcode,
        country
    } = address;
    return (
        <div id={id} className='p-3' style={{ minHeight: '230px' }}>
            <address>
                {addressLine1}
                <br />
                {addressLine2}
                <br />
                {townOrCity}
                <br />
                {region}
                <br />
                {postcode}
                <br />
                {country}
            </address>
            {showEditButton && (
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        id={'btnEditAddress'}
                        className='btn btn-primary'
                        onClick={onEditAddressClick}>
                        {t('edit_address')}
                    </button>
                </div>
            )}
        </div>
    );
};

export default Address;
